import springboard from 'springboard';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        UserContext: UserContextModuleReturnValue;
    }
}

export type UserContext = {
    type: 'remote';
    id: string;
} | {
    type: 'local';
}

type RpcStore = {getStore(): unknown};

type UserContextModuleReturnValue = {
    getUserContext: () => UserContext;
    setRpcStore: (rpcStore: RpcStore) => void;
};

springboard.registerModule('UserContext', {}, async (moduleAPI): Promise<UserContextModuleReturnValue> => {
    let rpcStore: RpcStore | undefined;

    const setRpcStore = (rpc: NonNullable<typeof rpcStore>) => {
        rpcStore = rpc;
    };

    const getUserContext = () => {
        if (!rpcStore) {
            return {
                type: 'local',
            } as const;
        }

        const context = rpcStore.getStore() as {local: true} | {id?: string} | null;
        if (context && ('local' in context)) {
            return {type: 'local'} as const;
        }

        if (!context?.id) {
            throw new Error('User is not logged in');
        }

        return {
            id: context.id,
            type: 'remote',
        } as const;
    };

    return {
        getUserContext,
        setRpcStore,
    };
});
